var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2856 3.47607L12.8725 10.1595C12.7669 11.867 12.7142 12.7208 12.2862 13.3347C12.0745 13.6381 11.8021 13.8943 11.4861 14.0867C10.847 14.4761 9.99164 14.4761 8.28078 14.4761C6.56772 14.4761 5.71118 14.4761 5.07168 14.086C4.75551 13.8932 4.48298 13.6366 4.27143 13.3326C3.84356 12.7178 3.79194 11.8628 3.68872 10.1529L3.28564 3.47607",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28564 3.47591H14.2856M10.9894 3.47591L10.5344 2.53706C10.232 1.91342 10.0808 1.60159 9.82011 1.40712C9.76231 1.36398 9.70105 1.3256 9.63698 1.29238C9.34825 1.14258 9.00171 1.14258 8.30864 1.14258C7.59818 1.14258 7.24298 1.14258 6.94943 1.29866C6.88438 1.33325 6.8223 1.37318 6.76384 1.41802C6.50007 1.62038 6.35273 1.94361 6.05805 2.59008L5.65426 3.47591",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61914 10.8096V6.80957",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95227 10.8096V6.80957",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIc);
export default __webpack_public_path__ + "static/media/delete_ic.b6564768e712e414c3a7ecf0915e6289.svg";
export { ForwardRef as ReactComponent };